/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GlobalConfiguration } from "../../../utils/configurationProvider.js";
import TEXT from "../../../utils/globalText.js";
import { globalTextFormat } from "../../../utils/globalTextFormat.js";
import AssignLabels from "../../_utils/AccountCreationComponents/AssignLabels/index.jsx";
import CommonLayout from "../../_utils/CommonLayout/index.jsx";
import CommonAssignLabelPopup from "../../_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import CategorySelector from "../../_utils/TransactionCommonComponents/CategorySelector.jsx";
import DynamicAdditionalFields from "../../_utils/TransactionCommonComponents/DynamicAdditionalFields.jsx";

const AdditionalDetails = ({
  categoryIds,
  selectedCategory,
  categories,
  catName,
  setCatSelect,
  catSelect,
  setSelectedCategory,
  handleCategorySelect,
  setDateRangeEnabled,
  setShowDatePicker,
  setShowDatePickerCal,
  setIsSingleDateSelected,
  mapingCat,
  setMapingCat,
  txnPayLoad,
  setQuantities,
  additionalData,
  setAdditionalData,
  copyData,
  setCopyData,
  setTimeData,
  setStartDateCal,
  setSelectedValueMonth,
  setSelectedValue,
  BenEnableNextButton,
  setTxnPayLoad,
  type,
  hyperLink,
  setHyperLink,
  timeData,
  quantities,
  uploadedFiles,
  setUploadedFiles,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  selectedValue,
  selectedValueMonth,
  initialRefactorAdditionalDetail,
  setInitialRefactorAdditionalDetail,
  previewImages,
  setPreviewImages,
}) => {
  const navigate = useNavigate();
  const dropdownRefs = useRef(null);
  const [loading, setLoading] = useState(false);
  const [dropdowns, setDropdowns] = useState({});
  const labelActionDispatchedRef = useRef(false);
  const [showLabelModal, setShowLabelModal] = useState(false);
  const [selectedLabelsCreate, setSelectedLabelsCreate] = useState(() => {
    const initialLabels = [
      ...(txnPayLoad?.labels || []),
      ...(txnPayLoad?.ownerLabels || []),
    ];
    return [...new Set(initialLabels)];
  });
  const [labels, setLabels] = useState(() => {
    const initialLabels = [
      ...(txnPayLoad?.labels || []),
      ...(txnPayLoad?.ownerLabels || []),
    ];
    return [...new Set(initialLabels)];
  });

  const [beneAccountId] = useState(
    txnPayLoad?.beneAccountId ? txnPayLoad?.beneAccountId : null,
  );

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const closeDropdowns = () => {
    setDropdowns((prev) => {
      const newDropdowns = Object.keys(prev).reduce((acc, key) => {
        acc[key] = { ...prev[key], isOpen: false };
        return acc;
      }, {});
      return newDropdowns;
    });
  };

  useEffect(() => {
    const handleClickOutside2 = (event) => {
      if (
        dropdownRefs.current &&
        !dropdownRefs.current.contains(event.target)
      ) {
        let obj = {
          ...dropdowns,
          isOpen: false,
        };
        setDropdowns(obj);
      }
    };

    document.addEventListener("mousedown", handleClickOutside2);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside2);
    };
  }, []);

  const handleQuantityChange = (value, fieldname, data_type, key) => {
    if (
      value < GlobalConfiguration.lengthCheckZero ||
      value.length > GlobalConfiguration.gstLength
    ) {
      return;
    }

    setQuantities((prev) => ({
      ...prev,
      [key]: value,
    }));

    handleInputChange({
      target: {
        name: fieldname,
        value: Number(value) || GlobalConfiguration.lengthCheckZero,
        data_typeChan: data_type,
      },
    });
  };

  const handleTimeConfirm = (
    fieldname,
    data_type,
    hourShow,
    minuteShow,
    meridiemShow,
  ) => {
    handleInputChange({
      target: {
        name: fieldname,
        value: `${hourShow}:${minuteShow} ${meridiemShow}`,
        data_typeChan: data_type,
      },
    });
  };

  const handleInputChange = (e, data_type) => {
    if (
      data_type === "numeric" &&
      e.target.value.length > GlobalConfiguration.gstLength
    )
      return;
    if (e.preventDefault) e.preventDefault();

    const {
      name,
      value,
      data_type: data_typeChan,
    } = e.target || {
      name: e.name,
      value: e.value,
    };

    const field = txnPayLoad?.selectedCategory?.configuration?.data?.find(
      (f) => f.name === name,
    );

    let updatedData = { ...additionalData };

    const isNonTrimmedType = [
      "date",
      "year",
      "toggle",
      "time",
      "quantity",
      "from_year_to_year",
      "month_year",
      "date_range",
      "multi_select_list",
      "upload",
    ].includes(data_typeChan);

    const trimmedValue =
      isNonTrimmedType || typeof value !== "string"
        ? value
        : value.replace(/^\s+/, "");

    if (field?.data_type === "month_year") {
      if (typeof value === "object" && value?.month && value?.year) {
        const monthNumber = (
          months.indexOf(value.month) + GlobalConfiguration.lengthCheckOne
        )
          .toString()
          .padStart(GlobalConfiguration.lengthCheckTwo, "0");

        updatedData[name] = `${monthNumber}/${value.year}`;
      } else if (typeof value === "string" && value.includes("/")) {
        updatedData[name] = value;
      }
    } else if (field?.data_type === "date_range") {
      if (typeof value === "string" && value.includes("-")) {
        const [start, end] = value.split("-").map((v) => v.trim());
        updatedData[name] = { start_date: start, end_date: end };
      } else if (value && typeof value === "object") {
        updatedData[name] = value;
      } else {
        updatedData[name] = { start_date: null, end_date: null };
      }
    } else {
      updatedData[name] = trimmedValue;
    }

    setAdditionalData(updatedData);

    if (field?.data_type === "list") {
      setDropdowns((prev) => ({
        ...prev,
        [name]: {
          ...prev[name],
          selectedOption: trimmedValue,
        },
      }));
    }
    if (field?.data_type === "numeric") {
      const cleaned = String(value).replace(/\D/g, "").slice(0, 15);
      updatedData[name] = cleaned;
    }

    return;
  };

  useEffect(() => {
    if (
      copyData?.value !== "" &&
      copyData?.title !== "" &&
      copyData?.data_type === "time"
    ) {
      const timeStr = copyData?.value;
      const [hourShow, rest] = timeStr.split(":");
      const [minuteShow, meridiemShow] = rest.split(" ");

      handleTimeConfirm(
        copyData?.title,
        copyData?.data_type,
        hourShow,
        minuteShow,
        meridiemShow,
      );

      setTimeData((prev) => {
        const key = `${copyData?.title}_${copyData?.data_type}`;
        return {
          ...prev,
          [key]: { hours: hourShow, minutes: minuteShow },
        };
      });

      setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      copyData?.value !== "" &&
      copyData?.title !== "" &&
      copyData?.data_type === "date"
    ) {
      handleInputChange({
        target: {
          name: copyData?.title,
          value: copyData?.value,
          data_typeChan: copyData?.data_type,
        },
      });

      let data = new Date(copyData?.value);

      setStartDateCal((prev) => {
        const key = `${copyData?.title}_${copyData?.data_type}`;

        return {
          ...prev,
          [key]: data,
        };
      });

      setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      copyData?.value !== "" &&
      copyData?.title !== "" &&
      copyData?.data_type === "quantity"
    ) {
      handleQuantityChange(
        copyData?.value || 0,
        copyData?.title,
        copyData?.data_type,
        `${copyData?.title}_${copyData?.data_type}`,
      );

      setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      copyData?.value !== "" &&
      copyData?.title !== "" &&
      copyData?.data_type === "toggle"
    ) {
      handleInputChange({
        target: {
          name: copyData?.title,

          value: copyData?.value,

          data_typeChan: copyData?.data_type,
        },
      });

      setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      copyData?.value !== "" &&
      copyData?.title !== "" &&
      copyData?.data_type === "month_year"
    ) {
      handleInputChange({
        target: {
          name: copyData?.title,

          value: copyData?.value,

          data_typeChan: copyData?.data_type,
        },
      });

      const [monthStr, yearStr] = copyData?.value.split("/");

      const monthIndex =
        parseInt(monthStr, GlobalConfiguration.panLength) -
        GlobalConfiguration.lengthCheckOne;

      const monthName = new Date(2000, monthIndex).toLocaleString("default", {
        month: "long",
      });

      const result = [
        monthName,
        parseInt(yearStr, GlobalConfiguration.panLength),
      ];

      setSelectedValueMonth((prev) => {
        const key = `${copyData?.title}_${copyData?.data_type}`;

        return {
          ...prev,

          [key]: { month: result[0], year: result[1] },
        };
      });

      setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      copyData?.value !== "" &&
      copyData?.title !== "" &&
      copyData?.data_type === "from_year_to_year"
    ) {
      handleInputChange({
        target: {
          name: copyData?.title,

          value: copyData?.value,

          data_typeChan: copyData?.data_type,
        },
      });

      setSelectedValue((prev) => {
        const key = `${copyData?.title}_${copyData?.data_type}`;

        return {
          ...prev,

          [key]: {
            from: copyData?.value?.from,

            to: copyData?.value?.to,
          },
        };
      });

      setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      copyData?.value !== "" &&
      copyData?.title !== "" &&
      copyData?.data_type === "date_range"
    ) {
      setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    }
  }, [copyData]);

  useEffect(() => {
    BenEnableNextButton(true);
  }, []);

  useEffect(() => {
    if (!additionalData) return;

    const storeData = txnPayLoad.selectedCategory?.configuration?.data?.map(
      (val) => {
        const dataValue = additionalData[val?.name];

        if (dataValue !== undefined && dataValue !== "") {
          if (val?.data_type === "numeric") {
            const finalValue = String(dataValue);
            return {
              ...val,
              value: finalValue,
            };
          }
          return {
            ...val,
            value: dataValue,
          };
        }

        if (val?.data_type === "multi_select_list") {
          return {
            ...val,
            value: [],
          };
        }

        if (val?.data_type === "toggle") {
          return {
            ...val,
            value: false,
          };
        }
        if (val?.data_type === "hyperlink") {
          return {
            ...val,
            value: "",
          };
        }

        if (val?.data_type === "date_range") {
          return { ...val, value: { start_date: null, end_date: null } };
        }

        if (val?.mandatory !== "Y") {
          return {
            ...val,
            value: "",
          };
        }

        return val;
      },
    );

    setTxnPayLoad({
      ...txnPayLoad,
      mergeCategory: storeData,
    });

    closeDropdowns();
  }, [additionalData, txnPayLoad.selectedCategory]);

  useEffect(() => {
    const labelTxnRaw = sessionStorage.getItem("AvailableLabelsTxnRem");
    const accountTxnRaw = sessionStorage.getItem("ReimburseAvailableLabels");

    const txnLabels = labelTxnRaw ? JSON.parse(labelTxnRaw) : [];
    const accounLabels = accountTxnRaw ? JSON.parse(accountTxnRaw) : [];

    const initialLabels = [
      ...(txnPayLoad?.labels || []),
      ...(txnPayLoad?.ownerLabels || []),
      ...txnLabels,
      ...accounLabels,
    ];

    const uniqueLabels = [...new Set(initialLabels)];

    setLabels(uniqueLabels);
  }, []);

  useEffect(() => {
    const ownerLabels = txnPayLoad?.ownerLabels || [];
    const labels = txnPayLoad?.labels || [];

    const combined = [
      ...ownerLabels,
      ...labels.filter((label) => !ownerLabels.includes(label)),
    ];

    setSelectedLabelsCreate(combined);
  }, [txnPayLoad?.ownerLabels, txnPayLoad?.labels]);

  const handleClose = (finalLabels) => {
    setShowLabelModal(false);
    if (!finalLabels) return;

    const currentOwnerLabels = txnPayLoad?.ownerLabels || [];

    const newOwnerLabels = finalLabels.filter((label) =>
      currentOwnerLabels.includes(label),
    );

    const newOtherLabels = finalLabels.filter(
      (label) => !currentOwnerLabels.includes(label),
    );

    setTxnPayLoad((prevPayload) => ({
      ...prevPayload,
      ownerLabels: newOwnerLabels,
      labels: newOtherLabels,
    }));
  };

  const [categoryLoading, setCategoryLoading] = useState(false);

  const handleUnassignNavigate = (id) => {
    navigate(
      `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_categories/${txnPayLoad.beneAccountId}`,
    );
  };
  const myHandleCategorySelect = (id) => {
    setCategoryLoading(true);
    setTimeout(() => {
      setCategoryLoading(false);
    }, 1000);
    const categoryData = categories.find((cat) => cat.id === id);
    if (selectedCategory?.id === id) {
      return;
    }
    if (txnPayLoad?.selectedCategory?.name === catName) {
      setCatSelect(false);
    }
    setSelectedCategory(categoryData);
    handleCategorySelect(categoryData);
    setTxnPayLoad({
      ...txnPayLoad,
      selectedCategory: categoryData,
    });
    setAdditionalData({});
    setSelectedValue({ from: "Select", to: "Select" });
    setDateRangeEnabled(false);
    setShowDatePicker({});
    setStartDate({});
    setEndDate({});
    setShowDatePickerCal({});
    setStartDateCal({});
    setIsSingleDateSelected(false);
    setHyperLink({});
    setPreviewImages({});
    setUploadedFiles({});
    setTimeData({});
    setQuantities({});
    setSelectedValueMonth({});
  };
  const unassignCategories = categories.filter((cat) => cat?.active === "Y");
  const unassignlength = unassignCategories.filter(
    (unassignCategory) => !categoryIds?.includes(unassignCategory.id),
  );

  // useEffect(() => {
  //   if (mapingCat === "renderCat" && catSelect) {
  //     myHandleCategorySelect(beneTxnAccountData?.transaction?.[0]?.category);
  //     setMapingCat(null);
  //   }
  // }, [mapingCat, catSelect]);
  // useEffect(() => {
  //   if (category.length === 1) {
  //     myHandleCategorySelect(category[0]);
  //   }
  // }, [category]);
  return (
    <>
      {showLabelModal && (
        <div className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            isLabelPopupOpen={showLabelModal}
            setPayload={setTxnPayLoad}
            txnPayLoad={txnPayLoad}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={setSelectedLabelsCreate}
            labelActionDispatchedRef={labelActionDispatchedRef}
            loading={loading}
            setLoading={setLoading}
            type="create"
          />
        </div>
      )}
      <div
        className="w-width-full Qlg:h-height-full h-auto justify-between items-start px-padding-md Qlg:px-padding-base pb-padding-md"
        style={{ scrollbarWidth: "none" }}
      >
        <CommonLayout>
          <div
            className={`w-width-full flex Qlg:flex-row flex-col justify-end items-start Qlg:gap-gap-xl ${type === "PayReimburseTxn" && "opacity-light-opacity pointer-events-none"} gap-gap-md`}
          >
            <div className="w-width-full lg:max-w-[var(--create-box-width)]">
              <CategorySelector
                beneAccountId={beneAccountId}
                category={categoryIds}
                selectedCategory={selectedCategory}
                unassignCategories={
                  type !== "PayReimburseTxn" ? unassignCategories : undefined
                }
                unassignlength={unassignlength}
                disableCategories={true}
                handleCategorySelect={myHandleCategorySelect}
                handleUnassignNavigate={handleUnassignNavigate}
                previewMode={false}
                variant={type === "PayReimburseTxn" ? "selected" : "list"}
                enableSearch={categoryIds.length !== 1}
                showUnassignCTA={type !== "PayReimburseTxn"}
              />
            </div>
          </div>

          <div className={`h-auto w-width-full flex flex-col gap-gap-md`}>
            <div
              className="w-width-full max-h-auto rounded-border-radius-md"
              style={{ scrollbarWidth: "none" }}
            >
              <div
                className={`${type === "PayReimburseTxn" && " opacity-light-opacity pointer-events-none"}`}
              >
                <DynamicAdditionalFields
                  isCategoryLoading={categoryLoading}
                  headerText={globalTextFormat(
                    TEXT.CATEGORY_SPECIFIC_DETAILS,
                    [0, 1, 2],
                  )}
                  mergeCategory={txnPayLoad?.mergeCategory}
                  additionalData={additionalData}
                  setAdditionalData={setAdditionalData}
                  hyperLink={hyperLink}
                  setHyperLink={setHyperLink}
                  timeData={timeData}
                  setTimeData={setTimeData}
                  quantities={quantities}
                  setQuantities={setQuantities}
                  uploadedFiles={uploadedFiles}
                  setUploadedFiles={setUploadedFiles}
                  startDate={startDate}
                  endDate={endDate}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  selectedValue={selectedValue}
                  setSelectedValue={setSelectedValue}
                  selectedValueMonth={selectedValueMonth}
                  setSelectedValueMonth={setSelectedValueMonth}
                  initialRefactorAdditionalDetail={
                    initialRefactorAdditionalDetail
                  }
                  setInitialRefactorAdditionalDetail={
                    setInitialRefactorAdditionalDetail
                  }
                  previewImages={previewImages}
                  setPreviewImages={setPreviewImages}
                  onInputChanged={(name, value, data_type) => {
                    handleInputChange({
                      target: {
                        name,
                        value,
                        data_typeChan: data_type,
                      },
                    });
                  }}
                />
              </div>
            </div>
            <AssignLabels
              setLabelpopup={setShowLabelModal}
              labels={selectedLabelsCreate}
              subText1={TEXT?.LABELS_USAGE_NOTE}
              subText2={TEXT?.LABELS_AUTO_ASSIGNED_NOTE}
              isOptional={true}
            />
          </div>
          {/* <div className="w-width-full Qmd:hidden block my-margin-xl lg:my-margin-base"></div> */}
        </CommonLayout>
      </div>
    </>
  );
};

export default AdditionalDetails;
